// src/app/config/customer1.config.ts

import {CustomerConfig} from "../CustomerConfig";

// PSH Config
export const customer3Config: CustomerConfig = {
  icons: {
    favIcon: 'park-service-huefner.svg',
    icon: 'park-service-huefner.svg',
  },
  strings: {
    title: 'Parkticket online bezahlen | Park Service Huefner',
    footerText: "test",
    email: "info@psh.de",
    number: "0800-72 75 737",
    contactRef: "https://www.ps-huefner.de/impressum.php",
    dataProtectionRef: "https://www.ps-huefner.de/datenschutz.php",
    metaDescription: "Parkticket jetzt online bezahlen mit Park Service Huefner – einfach, sicher & ohne Registrierung über bezahlen.psh.de . Kennzeichen eingeben, Zahlung abschließen & weiterfahren.",
  }
};
